<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">AQAR 2022 - 2023</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="/aqar">AQAR 2022 - 2023</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="online-anti-ragging ptb--100  verticaltab--1">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="row align-items-start hustify-content-center">
          <div class="nav flex-column nav-pills col-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <button class="nav-link active" id="v-pills-criteria1-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-criteria1" type="button" role="tab" aria-controls="v-pills-criteria1"
              aria-selected="true">Criteria-1</button>
            <button class="nav-link" id="v-pills-Criteria2-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria2" type="button" role="tab" aria-controls="v-pills-Criteria2"
              aria-selected="false">Criteria-2</button>
            <button class="nav-link" id="v-pills-Criteria3-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria3" type="button" role="tab" aria-controls="v-pills-Criteria3"
              aria-selected="false">Criteria-3</button>
            <button class="nav-link" id="v-pills-Criteria4-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria4" type="button" role="tab" aria-controls="v-pills-Criteria4"
              aria-selected="false">Criteria-4</button>
            <button class="nav-link" id="v-pills-Criteria5-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria5" type="button" role="tab" aria-controls="v-pills-Criteria5"
              aria-selected="false">Criteria-5</button>
            <button class="nav-link" id="v-pills-Criteria6-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria6" type="button" role="tab" aria-controls="v-pills-Criteria6"
              aria-selected="false">Criteria-6</button>
            <button class="nav-link" id="v-pills-Criteria7-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria7" type="button" role="tab" aria-controls="v-pills-Criteria7"
              aria-selected="false">Criteria-7</button>
            <button class="nav-link" id="v-pills-template-tab" data-bs-toggle="pill" data-bs-target="#v-pills-template"
              type="button" role="tab" aria-controls="v-pills-template" aria-selected="false">Extended Template</button>
          </div>
          <div class="tab-content col-9" id="v-pills-tabContent">
            <!-- criteria 1 -->
            <div class="tab-pane fade show active" id="v-pills-criteria1" role="tabpanel"
              aria-labelledby="v-pills-criteria1-tab">
              <h3 class="yellow-color">Criteria 1</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria1">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-1-1" aria-expanded="true" aria-controls="criteria1-2-1">
                      1.1
                    </h2>
                    <div id="criteria1-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria1-1"
                      data-bs-parent="#criteria1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-1/1.1.1.pdf"
                              target="_blank">1.1.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-1/1.1.2.pdf"
                              target="_blank">1.1.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-1/1.1.3.pdf"
                              target="_blank">1.1.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-3-2" aria-expanded="true" aria-controls="collapseOne">
                      1.3
                    </h2>
                    <div id="criteria1-3-2" class="accordion-collapse collapse" aria-labelledby="criteria1-3"
                      data-bs-parent="#criteria1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="javascript:void(0);">1.3.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-1/1.3.2.pdf"
                              target="_blank">1.3.2</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">1.3.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_1">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-2-1" aria-expanded="true" aria-controls="criteria1-2-1">
                      1.2
                    </h2>
                    <div id="criteria1-2-1" class="accordion-collapse collapse" aria-labelledby="criteria1-2"
                      data-bs-parent="#criteria_1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-1/1.2.1.pdf"
                              target="_blank">1.2.1</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">1.2.2</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">1.2.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-4-2" aria-expanded="true" aria-controls="collapseOne">
                      1.4
                    </h2>
                    <div id="criteria1-4-2" class="accordion-collapse collapse" aria-labelledby="criteria1-4"
                      data-bs-parent="#criteria_1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="javascript:void(0);">1.4.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-1/1.4.2.pdf"
                              target="_blank">1.4.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 2 -->
            <div class="tab-pane fade" id="v-pills-Criteria2" role="tabpanel" aria-labelledby="v-pills-Criteria2-tab">
              <h3 class="yellow-color">Criteria 2</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria2">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-1-2" aria-expanded="true" aria-controls="collapseOne">
                      2.1
                    </h2>
                    <div id="criteria2-1-2" class="accordion-collapse collapse show" aria-labelledby="criteria2-1"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.1.1.pdf"
                              target="_blank">2.1.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.1.2.pdf"
                              target="_blank">2.1.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-3-1" aria-expanded="true" aria-controls="collapseOne">
                      2.3
                    </h2>
                    <div id="criteria2-3-1" class="accordion-collapse collapse" aria-labelledby="criteria2-3"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.3.1.pdf"
                              target="_black">2.3.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.3.2.pdf"
                              target="_black">2.3.2</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">2.3.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-5" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-5-2" aria-expanded="true" aria-controls="collapseOne">
                      2.5
                    </h2>
                    <div id="criteria2-5-2" class="accordion-collapse collapse" aria-labelledby="criteria2-5"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.5.1.pdf"
                              target="_blank">2.5.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.5.2.pdf"
                              target="_blank">2.5.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_2">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-2-2" aria-expanded="true" aria-controls="collapseOne">
                      2.2
                    </h2>
                    <div id="criteria2-2-2" class="accordion-collapse collapse" aria-labelledby="criteria2-2"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.2.1.pdf"
                              target="_blank">2.2.1</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">2.2.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-4-1" aria-expanded="true" aria-controls="collapseOne">
                      2.4
                    </h2>
                    <div id="criteria2-4-1" class="accordion-collapse collapse" aria-labelledby="criteria2-4"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.4.1.pdf"
                              target="_blank">2.4.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.4.2.pdf"
                              target="_blank">2.4.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.4.3.pdf"
                              target="_blank">2.4.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-6" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-6-2" aria-expanded="true" aria-controls="collapseOne">
                      2.6
                    </h2>
                    <div id="criteria2-6-2" class="accordion-collapse collapse" aria-labelledby="criteria2-6"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.6.1.pdf"
                              target="_blank"> 2.6.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.6.2.pdf"
                              target="_blank">2.6.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.6.3-0001.pdf"
                              target="_blank">2.6.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-7" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-7-1" aria-expanded="true" aria-controls="collapseOne">
                      2.7
                    </h2>
                    <div id="criteria2-7-1" class="accordion-collapse collapse" aria-labelledby="criteria2-7"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before main-list">
                          <li>
                            <h6>2.7.1</h6>
                            <ul class="sublist">
                              <li>
                                <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-2/2.7.1.pdf"
                                  target="_blank">2.7.1</a>
                              </li>
                              <li>
                                <a href="https://docs.google.com/spreadsheets/d/1mVpaFp7FeUb24QtKhFWnwamjgPWp45Wq/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true"
                                  target="_blank">2.7.1 Template</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 3 -->
            <div class="tab-pane fade" id="v-pills-Criteria3" role="tabpanel" aria-labelledby="v-pills-Criteria3-tab">
              <h3 class="yellow-color">Criteria 3</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria3">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-1-1" aria-expanded="true" aria-controls="collapseOne">
                      3.1
                    </h2>
                    <div id="criteria3-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria3-1"
                      data-bs-parent="#criteria3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-3/3.1.3.pdf"
                              target="_blank">3.1.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-3-1" aria-expanded="true" aria-controls="collapseOne">
                      3.3
                    </h2>
                    <div id="criteria3-3-1" class="accordion-collapse collapse" aria-labelledby="criteria3-3"
                      data-bs-parent="#criteria3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="javascript:void(0);">3.3.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-3/3.3.2.pdf"
                              target="_blank">3.3.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-3/3.3.3-3.3.4.pdf"
                              target="_blank">3.3.3 & 3.3.4</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_3">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-4-1" aria-expanded="true" aria-controls="collapseOne">
                      3.4
                    </h2>
                    <div id="criteria3-4-1" class="accordion-collapse collapse show" aria-labelledby="criteria3-4"
                      data-bs-parent="#criteria_3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-3/3.4.1.pdf"
                              target="_blank">3.4.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-3/3.4.2.pdf"
                              target="_blank">3.4.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 4 -->
            <div class="tab-pane fade" id="v-pills-Criteria4" role="tabpanel" aria-labelledby="v-pills-Criteria4-tab">
              <h3 class="yellow-color">Criteria 4</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria4">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-1-1" aria-expanded="true" aria-controls="collapseOne">
                      4.1
                    </h2>
                    <div id="criteria4-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria4-1"
                      data-bs-parent="#criteria4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-4/4.1.1-final.pdf"
                              target="_blank">4.1.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-4/4.1.2-final.pdf"
                              target="_blank">4.1.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-4/4.1.3-final.pdf"
                              target="_blank">4.1.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-3-1" aria-expanded="true" aria-controls="collapseOne">
                      4.3
                    </h2>
                    <div id="criteria4-3-1" class="accordion-collapse collapse" aria-labelledby="criteria4-3"
                      data-bs-parent="#criteria4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-4/4.3.1.pdf"
                              target="_blank">4.3.1</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_4">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-2-1" aria-expanded="true" aria-controls="collapseOne">
                      4.2
                    </h2>
                    <div id="criteria4-2-1" class="accordion-collapse collapse" aria-labelledby="criteria4-2"
                      data-bs-parent="#criteria_4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-4/4.2.1-final.pdf"
                              target="_blank">4.2.1</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">4.2.4</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-2-3" aria-expanded="true" aria-controls="collapseOne">
                      4.4
                    </h2>
                    <div id="criteria4-2-3" class="accordion-collapse collapse" aria-labelledby="criteria4-3"
                      data-bs-parent="#criteria_4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-4/4.4.2-final.pdf"
                              target="_blank">4.4.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 5 -->
            <div class="tab-pane fade" id="v-pills-Criteria5" role="tabpanel" aria-labelledby="v-pills-Criteria5-tab">
              <h3 class="yellow-color">Criteria 5</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria5">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-1-1" aria-expanded="true" aria-controls="collapseOne">
                      5.1
                    </h2>
                    <div id="criteria5-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria5-1"
                      data-bs-parent="#criteria5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.1.1.pdf"
                              target="_blank">5.1.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.1.2.pdf"
                              target="_blank">5.1.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.1.3.pdf"
                              target="_blank">5.1.3</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.1.4.pdf"
                              target="_blank">5.1.4</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">5.1.5</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-3-1" aria-expanded="true" aria-controls="collapseOne">
                      5.3
                    </h2>
                    <div id="criteria5-3-1" class="accordion-collapse collapse" aria-labelledby="criteria5-3"
                      data-bs-parent="#criteria5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.3.1.pdf"
                              target="_blank">5.3.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.3.2.pdf"
                              target="_blank">5.3.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.3.3.pdf"
                              target="_blank">5.3.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_5">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-2-2" aria-expanded="true" aria-controls="collapseOne">
                      5.2
                    </h2>
                    <div id="criteria5-2-2" class="accordion-collapse collapse" aria-labelledby="criteria5-2"
                      data-bs-parent="#criteria_5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.2.1.pdf"
                              target="_blank">5.2.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.2.2.pdf"
                              target="_blank">5.2.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.2.3.pdf"
                              target="_blank">5.2.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-4-1" aria-expanded="true" aria-controls="collapseOne">
                      5.4
                    </h2>
                    <div id="criteria5-4-1" class="accordion-collapse collapse" aria-labelledby="criteria5-4"
                      data-bs-parent="#criteria_5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-5/5.4.1.pdf"
                              target="_blank">5.4.1</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 6 -->
            <div class="tab-pane fade" id="v-pills-Criteria6" role="tabpanel" aria-labelledby="v-pills-Criteria6-tab">
              <h3 class="yellow-color">Criteria 6</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria6">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-1-1" aria-expanded="true" aria-controls="collapseOne">
                      6.1
                    </h2>
                    <div id="criteria6-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria6-1"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.1.1.pdf"
                              target="_blank">6.1.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.1.2.pdf"
                              target="_blank">6.1.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-3-1" aria-expanded="true" aria-controls="collapseOne">
                      6.3
                    </h2>
                    <div id="criteria6-3-1" class="accordion-collapse collapse" aria-labelledby="criteria6-3"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.3.1.pdf"
                              target="_blank">6.3.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.3.2.pdf"
                              target="_blank">6.3.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.3.3.pdf"
                              target="_blank">6.3.3</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">6.3.4</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.3.5.pdf"
                              target="_blank">6.3.5</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-5" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-5-1" aria-expanded="true" aria-controls="collapseOne">
                      6.5
                    </h2>
                    <div id="criteria6-5-1" class="accordion-collapse collapse" aria-labelledby="criteria6-5"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.5.1.pdf"
                              target="_blank">6.5.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.5.2.pdf"
                              target="_blank">6.5.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.5.3.pdf"
                              target="_blank">6.5.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_6">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-2-3" aria-expanded="true" aria-controls="collapseOne">
                      6.2
                    </h2>
                    <div id="criteria6-2-3" class="accordion-collapse collapse" aria-labelledby="criteria6-2"
                      data-bs-parent="#criteria_6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.2.1.pdf"
                              target="_blank">6.2.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.2.2.pdf"
                              target="_blank">6.2.2</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.2.3.pdf"
                              target="_blank">6.2.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-4-1" aria-expanded="true" aria-controls="collapseOne">
                      6.4
                    </h2>
                    <div id="criteria6-4-1" class="accordion-collapse collapse" aria-labelledby="criteria6-4"
                      data-bs-parent="#criteria_6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.4.1.pdf"
                              target="_black">6.4.1</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-6/6.4.3.pdf"
                              target="_black">6.4.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 7 -->
            <div class="tab-pane fade" id="v-pills-Criteria7" role="tabpanel" aria-labelledby="v-pills-Criteria7-tab">
              <h3 class="yellow-color">Criteria 7</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria7">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-1-2" aria-expanded="true" aria-controls="collapseOne">
                      7.1
                    </h2>
                    <div id="criteria7-1-2" class="accordion-collapse collapse" aria-labelledby="criteria7-1"
                      data-bs-parent="#criteria7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.1.pdf"
                              target="_blank">7.1.1 </a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.2.pdf"
                              target="_blank">7.1.2 </a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.3-0001.pdf"
                              target="_blank">7.1.3</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.4-0001.pdf"
                              target="_blank">7.1.4 </a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.5-0001.pdf"
                              target="_blank">7.1.5 </a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.6.pdf"
                              target="_blank">7.1.6
                            </a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.7-0001.pdf"
                              target="_blank">7.1.7</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.8.pdf"
                              target="_blank">7.1.8</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.9.pdf"
                              target="_blank">7.1.9</a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.10-0001.pdf"
                              target="_blank">7.1.10 </a>
                          </li>
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.1.11.pdf"
                              target="_blank">7.1.11</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-3-1" aria-expanded="true" aria-controls="collapseOne">
                      7.3
                    </h2>
                    <div id="criteria7-3-1" class="accordion-collapse collapse" aria-labelledby="criteria7-3"
                      data-bs-parent="#criteria7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.3.1.pdf"
                              target="_blank">7.3.1 </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_7">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-2-1" aria-expanded="true" aria-controls="collapseOne">
                      7.2
                    </h2>
                    <div id="criteria7-2-1" class="accordion-collapse collapse" aria-labelledby="criteria7-2"
                      data-bs-parent="#criteria_7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-23/criteria-7/7.2.1.pdf"
                              target="_blank">7.2.1 </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- extended template -->
            <div class="tab-pane fade" id="v-pills-template" role="tabpanel" aria-labelledby="v-pills-template-tab">
              <h3 class="yellow-color">Extended Template</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="template">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="extended" data-bs-toggle="collapse"
                      data-bs-target="#extended_template" aria-expanded="true" aria-controls="collapseOne">
                      Extended Template
                    </h2>
                    <div id="extended_template" class="accordion-collapse collapse" aria-labelledby="extended"
                      data-bs-parent="#template">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="javascript:void(0);">3.2</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
